import { useCallback, useEffect } from "react";

import { AddAddressModal } from "@/components/Modals/AddAddressModal";
import { DuplicateByAddressModal } from "@/components/Modals/DuplicateByAddressModal";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setMarketCreatePageModal } from "@/store/slices/ui";
import { MarketCreateModal } from "@/types/modals";

import { AddIllegalEntityModal } from "./components/AddIllegalEntityModal";
import { AddLegalEntityModal } from "./components/AddLegalEntityModal";
import { AddNetworkModal } from "./components/AddNetworkModal";
import { DuplicateByIdModal } from "./components/DuplicateByIdModal";

export const ModalsContainer = () => {
    const dispatch = useAppDispatch();
    const { modal } = useAppSelector((s) => s.ui.marketCreatePage);

    const onClose = useCallback(() => {
        dispatch(setMarketCreatePageModal(null));
    }, [dispatch]);

    useEffect(() => {
        dispatch(setMarketCreatePageModal(null));
    }, [dispatch]);

    if (!modal) return null;

    switch (modal.type) {
        case MarketCreateModal.AddAddress: {
            return (
                <AddAddressModal onClose={onClose} payload={modal.payload} />
            );
        }
        case MarketCreateModal.AddLegalEntity: {
            return <AddLegalEntityModal onClose={onClose} />;
        }

        case MarketCreateModal.DuplicateByAddress: {
            return (
                <DuplicateByAddressModal
                    onClose={onClose}
                    payload={modal.payload}
                />
            );
        }

        case MarketCreateModal.DuplicateById: {
            return (
                <DuplicateByIdModal onClose={onClose} payload={modal.payload} />
            );
        }

        case MarketCreateModal.AddNetwork: {
            return <AddNetworkModal onClose={onClose} />;
        }

        case MarketCreateModal.AddIllegalEntity: {
            return <AddIllegalEntityModal onClose={onClose} />;
        }
        default:
            return null;
    }
};
